module.exports = __webpack_public_path__ + "static/media/logo-st-label.5319f505.png";